import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppDashboardPage } from './app-dashboard';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppDashboardPage,
  ],
  imports: [
    IonicPageModule.forChild(AppDashboardPage),
    PipesModule,
    DirectivesModule,

  ],
})
export class AppDashboardPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-dashboard/app-dashboard.module.ts